export const PREFERRED_THEME_MODE_COOKIE = 'preferred-theme-mode';
export const I18N_NEXT_COOKIE = 'next-i18next';
export const OIDC_USER_AGENT_COOKIE = 'oidc_user_agent';
export const SELECTED_SSO_SLUG_COOKIE = 'selected_sso_slug';

const NON_SENSITIVE_COOKIES = [
    I18N_NEXT_COOKIE,
    OIDC_USER_AGENT_COOKIE,
    PREFERRED_THEME_MODE_COOKIE,
    SELECTED_SSO_SLUG_COOKIE
];

export const getNonSensitiveCookies = (cookies: string = '') => {
    return cookies
        .split('; ')
        .filter((cookie) =>
            NON_SENSITIVE_COOKIES.some((nonSensitiveCookie) =>
                cookie.startsWith(nonSensitiveCookie)
            )
        )
        .join('; ');
};
